import React from "react";
import requireAuth from "../auth/requireAuth";
import ContractTableGrid from "./ContractTableGrid";

class ContractList extends React.Component {
  render() {
    return (
      <div className="ui centered grid">
        <div className="ui fifteen wide column">
          <ContractTableGrid />
        </div>
      </div>
    );
  }
}

export default requireAuth(ContractList);
